// removed by extract-text-webpack-plugin
module.exports = {"access-container":"app-pages-Employees-Role-RoleDetail-RoleForm-__RoleForm___3BPip","title":"app-pages-Employees-Role-RoleDetail-RoleForm-__RoleForm___WZvi4","form":"app-pages-Employees-Role-RoleDetail-RoleForm-__RoleForm___1Rwuy","container":"app-pages-Employees-Role-RoleDetail-RoleForm-__RoleForm___1qRYX","no-employee":"app-pages-Employees-Role-RoleDetail-RoleForm-__RoleForm___38MPl","footer":"app-pages-Employees-Role-RoleDetail-RoleForm-__RoleForm___2YQVx","ellipsis":"app-pages-Employees-Role-RoleDetail-RoleForm-__RoleForm___1Gmlc"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/Role/RoleDetail/RoleForm/RoleForm.css
// module id = 2331
// module chunks = 0